<template>
  <div v-if="left && right" class="drawer-details-split">
    <div class="left">
      <span class="label">{{left.label}}</span>
      <span class="value">{{left.value}}</span>
      <span v-if="left.suffix" class="suffix">{{left.suffix}}</span>
    </div>
    <div class="right">
      <span class="label">{{right.label}}</span>
      <span class="value">{{right.value}}</span>
      <span v-if="right.suffix" class="suffix">{{right.suffix}}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Info {
  label:string;
  value:string;
  suffix?:string;
}

defineProps<{
  left?:Info,
  right?:Info,
}>();
</script>

<style lang="scss">
.drawer-details-split {
  display: grid;
  grid-template-columns: auto auto;

  .label {
    display: block;
    font-size: 12px;
  }

  .value {
    font-size: 24px;
    line-height: 1.2;
    font-weight: 600;
  }

  .suffix {
    font-size: 14px;
  }
}
</style>
